import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../utils/APIS";
import { IDS } from "../utils/IDS";
import { GET } from "../utils/Methods";

export const GetAllaboutbanner = createAsyncThunk(
  "masters/banner/get-all",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.aboutbanner}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetAllCount = createAsyncThunk(
  "masters/count/get-all",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.count}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetAllwhoweare = createAsyncThunk(
  "masters/whoweare/get-all",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.whoweare}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetAllwhychoose = createAsyncThunk(
  "masters/whychoose/get-all",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.whychoose}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetAllfeedback = createAsyncThunk(
  "masters/feedback/get-all",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.feedback}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetAllfaq = createAsyncThunk(
  "masters/faq/get-all",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.faq}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "aboutus",
  initialState: {
  aboutbanner: [],
  count:[],
  whoweare:[],
  whychoose:[],
  feedback:[],
  faq:[],
  

  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(GetAllaboutbanner.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllaboutbanner.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.aboutbanner = action.payload?.data || [];
      })
      .addCase(GetAllaboutbanner.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
       })
     
      //count
      .addCase(GetAllCount.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllCount.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.count = action.payload?.data || [];
      })
      .addCase(GetAllCount.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      
       
      .addCase(GetAllwhoweare.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllwhoweare.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.whoweare = action.payload?.data || [];
      })
      .addCase(GetAllwhoweare.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

    
      .addCase(GetAllwhychoose.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllwhychoose.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.whychoose = action.payload?.data || [];
      })
      .addCase(GetAllwhychoose.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

       
      .addCase(GetAllfeedback.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllfeedback.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.feedback = action.payload?.data || [];
      })
      .addCase(GetAllfeedback.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
       })

         .addCase(GetAllfaq.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllfaq.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.faq = action.payload?.data || [];
      })
      .addCase(GetAllfaq.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
